import { css } from '@/styled-system/css';

export const upsellBannerActionStyles = css.raw({
  flexShrink: 0,
  marginBlockStart: {
    lgDown: 'UpsellBanner.Action.margin.content-toActions.vert',
  },
  marginInlineEnd: {
    lg: 'UpsellBanner.Root.gap.trailing',
  },
});
